import { jsx as i } from "react/jsx-runtime";
import a from "classnames";
import m from "../../utils/colors.js";
import { f } from "../../styled-qu50FBLM.mjs";
import { Svg as n, Path as s } from "./Elements.js";
const g = ({
  className: r = "",
  fill: o = m.blueGrey,
  viewBox: l = "0 0 14.99 9.01",
  $cssHelper: e = f,
  focusable: t
}) => /* @__PURE__ */ i(
  n,
  {
    className: a({ [r]: !!r }),
    viewBox: l,
    $cssHelper: e,
    "aria-label": "Arrow Right Icon",
    role: "img",
    focusable: !!t,
    "aria-hidden": !t,
    children: /* @__PURE__ */ i(
      s,
      {
        color: o,
        fill: o,
        d: "M10.41.01L8.99 1.36l2.23 2.19H-.01v1.92h11.27L8.99 7.66l1.42 1.35 4.58-4.51z",
        $transition: "fill 0.1s ease-in-out"
      }
    )
  }
);
export {
  g as default
};
